const AttachmentConstants = {
  images: [
    'jpeg',
    'jpg',
    'png',
    'svg',
  ],
  pdf: [
    'pdf',
    'txt',
    'doc',
    'docx',
    'docm',
  ],
  excel: [
    'xls',
    'xlt',
    'xlm',
    'xlsx',
    'xlsm',
    'xltx',
    'xltm',
    'csv'
  ],
  zpl: [
    'zpl',
  ],
  email: [
    'eml',
  ],
  msg: [
    'msg',
  ],
  zip: [
    'zip',
  ],
  excelMimes: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.template, application/vnd.ms-excel.sheet.macroEnabled.12, application/vnd.ms-excel.template.macroEnabled.12, text/csv',
  maxMbSize: 12, // max mb size per attachment
};

module.exports = AttachmentConstants;
